import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE } from "../utils/apiBase";
import "./PetsPage.css";

export default function LostPetPublicPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    fetch(`${API_BASE}/pets/public/lost/${encodeURIComponent(token)}`)
      .then(async response => {
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || "This page is unavailable.");
        setData(payload);
      })
      .catch(err => setError(err.message));
  }, [token]);
  if (error) return <main className="hm-public-lost"><section><h1>Lost-pet page unavailable</h1><p>{error}</p></section></main>;
  if (!data) return <main className="hm-public-lost"><section><p>Loading lost-pet details…</p></section></main>;
  return <main className="hm-public-lost">
    <section>
      <small>HouseMind lost-pet alert</small>
      {data.photo_url ? <img src={data.photo_url} alt={data.pet_name} /> : <i>🐾</i>}
      <h1>Help find {data.pet_name}</h1>
      <h2>LOST {String(data.species || "PET").toUpperCase()}</h2>
      <p>{[data.breed, data.color_markings].filter(Boolean).join(" · ")}</p>
      {data.microchipped && <strong>✓ Microchipped</strong>}
      {data.last_seen_date && <p><b>Last seen:</b> {data.last_seen_date}{data.last_seen_location ? ` · ${data.last_seen_location}` : ""}</p>}
      {data.public_notes && <p>{data.public_notes}</p>}
      {data.contact_phone && <a href={`tel:${data.contact_phone}`}>Call {data.contact_name || "owner"}</a>}
      <footer>Only owner-approved public information is shown. This page expires automatically.</footer>
    </section>
  </main>;
}
